import { render, staticRenderFns } from "./AdditionalSampleModal.vue?vue&type=template&id=64bc13ce&scoped=true&"
import script from "./AdditionalSampleModal.vue?vue&type=script&lang=ts&"
export * from "./AdditionalSampleModal.vue?vue&type=script&lang=ts&"
import style0 from "./AdditionalSampleModal.vue?vue&type=style&index=0&id=64bc13ce&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64bc13ce",
  null
  
)

export default component.exports